import { Action, createReducer, on } from '@ngrx/store';
import { fromProductSwitchLockPeriodsAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const productSwitchLockPeriodsFeatureKey = 'productSwitchLockPeriods';

export interface ProductSwitchLockPeriodsState {
  productSwitchLockPeriodsResponse: IStaticDataResponse[];
  productSwitchLockPeriodsFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: ProductSwitchLockPeriodsState = {
  productSwitchLockPeriodsFailure: undefined,
  productSwitchLockPeriodsResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromProductSwitchLockPeriodsAction.loadProductSwitchLockPeriods, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromProductSwitchLockPeriodsAction.loadProductSwitchLockPeriodsSuccess, (state, action) => ({
    ...state,
    productSwitchLockPeriodsResponse: action.response
  })),

  on(fromProductSwitchLockPeriodsAction.loadProductSwitchLockPeriodsFailure, (state, action) => ({
    ...state,
    productSwitchLockPeriodsFailure: action.error
  }))
);

export const getProductSwitchLockPeriodsResponse = (state: ProductSwitchLockPeriodsState) => state.productSwitchLockPeriodsResponse;
export const getProductSwitchLockPeriodsFailure = (state: ProductSwitchLockPeriodsState) => state.productSwitchLockPeriodsFailure;
export const getProductSwitchLockPeriodsIsLoaded = (state: ProductSwitchLockPeriodsState) => state.loaded;
